import React from "react";
import {FormattedMessage} from "react-intl";

import Icon from "../Icon";

import classes from "./styles.module.css";

function SearchString({placeholder, searchString, isDisabled, onChangeSearch}) {

    return (
        <div className={classes.Card}>
            <FormattedMessage id={placeholder}>
                {placeholder => (
                    <input className={classes.Input}
                           type="text"
                           value={searchString}
                           onChange={(e) => onChangeSearch(e.target.value)}
                           placeholder={placeholder}
                           disabled={isDisabled}
                    />
                )}
            </FormattedMessage>

            <Icon className={classes.Icon} color={'#999'} icon="search" size={'20px'}/>
        </div>
    )
}

export default SearchString;


// WEBPACK FOOTER //
// ./src/Components/Utils/SearchString/index.js